import { render, staticRenderFns } from "./TrophyForm.vue?vue&type=template&id=cc383f54&"
import script from "./TrophyForm.vue?vue&type=script&lang=js&"
export * from "./TrophyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports